import { EmployeeSummaryDto } from './employee-summary-dto.model';
import { CompanyDto } from './company-dto.model';
import { ProjectDto } from './project-dto.model';
import { VehicleType,TransactionStatus } from '../service-proxies';


export class FuelAllowanceApplicationDto implements IFuelAllowanceApplicationDto {
    id!: number;
    employee!: EmployeeSummaryDto;
    transactionDate!: Date;
    vehicleTypeId!: VehicleType;
    vehicleTypeName!: string | undefined;
    requestKM!: number;
    approver!: EmployeeSummaryDto;
    approveKM!: number;
    fuelAllowanceStatus!: TransactionStatus;
    fuelAllowanceStatusType!: string | undefined;
    remark!: string | undefined;
    company!: CompanyDto;
    project!: ProjectDto;
    vehicleNo!: string | undefined;

    constructor(data?: IFuelAllowanceApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.vehicleTypeName = _data["vehicleTypeName"];
            this.requestKM = _data["requestKM"];
            this.approver = _data["approver"] ? EmployeeSummaryDto.fromJS(_data["approver"]) : <any>undefined;
            this.approveKM = _data["approveKM"];
            this.fuelAllowanceStatus = _data["fuelAllowanceStatus"];
            this.fuelAllowanceStatusType = _data["fuelAllowanceStatusType"];
            this.remark = _data["remark"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.project = _data["project"] ? ProjectDto.fromJS(_data["project"]) : <any>undefined;
            this.vehicleNo = _data["vehicleNo"];
        }
    }

    static fromJS(data: any): FuelAllowanceApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelAllowanceApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["vehicleTypeName"] = this.vehicleTypeName;
        data["requestKM"] = this.requestKM;
        data["approver"] = this.approver ? this.approver.toJSON() : <any>undefined;
        data["approveKM"] = this.approveKM;
        data["fuelAllowanceStatus"] = this.fuelAllowanceStatus;
        data["fuelAllowanceStatusType"] = this.fuelAllowanceStatusType;
        data["remark"] = this.remark;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["vehicleNo"] = this.vehicleNo;
        return data; 
    }
}

export interface IFuelAllowanceApplicationDto {
    id: number;
    employee: EmployeeSummaryDto;
    transactionDate: Date;
    vehicleTypeId: VehicleType;
    vehicleTypeName: string | undefined;
    requestKM: number;
    approver: EmployeeSummaryDto;
    approveKM: number;
    fuelAllowanceStatus: TransactionStatus;
    fuelAllowanceStatusType: string | undefined;
    remark: string | undefined;
    company: CompanyDto;
    project: ProjectDto;
    vehicleNo: string | undefined;
}

